// removed by extract-text-webpack-plugin
module.exports = {"wrap":"CwToggleButton-wrap","inner":"CwToggleButton-inner","innerEnabled":"CwToggleButton-innerEnabled","innerActive":"CwToggleButton-innerActive"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwtogglebutton/CwToggleButton.scss
// module id = 394
// module chunks = 0